import { useLazyQuery } from "@apollo/client";
import { isArray } from "lodash";
import {
  GET_DYLOG_FOREIGN_COUNTRIES,
  GET_DYLOG_MUNICIPALITIES,
  GET_DYLOG_PROVINCES,
  GET_DYLOG_TYPONYMS,
} from "../../graphql/queries/dylog.query";

interface Entity {
  id: string;
  description: string;
}

const queryDataMap = {
  municipalities: {
    query: GET_DYLOG_MUNICIPALITIES,
    key: "getPaginatedMunicipalities",
  },
  provinces: { query: GET_DYLOG_PROVINCES, key: "getPaginatedProvinces" },
  foreignCountries: {
    query: GET_DYLOG_FOREIGN_COUNTRIES,
    key: "getPaginatedForeignCountries",
  },
  typonyms: { query: GET_DYLOG_TYPONYMS, key: "getPaginatedTyponyms" },
};

const useSortedLazyQuery = (
  type: keyof typeof queryDataMap,
  setState: (data: { value: string; display: string }[]) => void
) => {
  const { query, key } = queryDataMap[type];

  return useLazyQuery(query, {
    onCompleted(data) {
      const actualData: Entity[] = isArray(data?.[key]?.data)
        ? data[key].data
        : [];
      setState(
        actualData.map(({ id, description }) => ({
          value: id,
          display: description,
        }))
      );
    },
  });
};

export { useSortedLazyQuery };
